module.exports = {
  "videoUsage": {
    "name": "video-usage",
    "class": "usage",
    "properties": {
      "type": [
        "rendered",
        "loaded",
        "started",
        "engaged",
        "finished",
        "minutes-watched"
      ],
      "playerType": "string",
      "videoId": "string",
      "viewDuration": {
        "type": "number",
        "isOptional": true
      },
      "autoPlay": {
        "type": "boolean",
        "isOptional": true
      },
      "playlistId": {
        "type": "string",
        "isOptional": true
      },
      "playlistName": {
        "type": "string",
        "isOptional": true
      },
      "isHubspotPlaylist": {
        "type": "boolean",
        "isOptional": true
      },
      "creatorHubId": {
        "type": "number",
        "isOptional": true
      },
      "contentId": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "videoType": {
        "type": "string",
        "isOptional": true
      },
      "platform": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "learning-center"
  },
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "allCategories": {
        "type": "string",
        "isOptional": true
      },
      "lessonId": {
        "type": "string",
        "isOptional": true
      },
      "contentId": {
        "type": "string",
        "isOptional": true
      },
      "contentName": {
        "type": "string",
        "isOptional": true
      },
      "lessonName": {
        "type": "string",
        "isOptional": true
      },
      "contentType": {
        "type": "string",
        "isOptional": true
      },
      "hsSoftwareFilters": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "profileId": {
        "type": "string",
        "isOptional": true
      },
      "platform": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "learning-center"
  },
  "subpageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "examId": {
        "type": "string",
        "isOptional": true
      },
      "allCategories": {
        "type": "string",
        "isOptional": true
      },
      "lessonId": {
        "type": "string",
        "isOptional": true
      },
      "trackId": {
        "type": "string",
        "isOptional": true
      },
      "contentId": {
        "type": "string",
        "isOptional": true
      },
      "lessonName": {
        "type": "string",
        "isOptional": true
      },
      "trackName": {
        "type": "string",
        "isOptional": true
      },
      "hsSoftwareFilters": {
        "type": "string",
        "isOptional": true
      },
      "trackIsComplete": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": "string",
      "platform": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "learning-center"
  },
  "interaction": {
    "name": "learning center interaction",
    "class": "interaction",
    "properties": {
      "href": {
        "type": "string",
        "isOptional": true
      },
      "is_enrolled": {
        "type": "string",
        "isOptional": true
      },
      "newLanguage": {
        "type": "string",
        "isOptional": true
      },
      "assetId": {
        "type": "string",
        "isOptional": true
      },
      "isEnrolledOverridable": {
        "type": "string",
        "isOptional": true
      },
      "jobRole": {
        "type": "string",
        "isOptional": true
      },
      "search": {
        "type": "string",
        "isOptional": true
      },
      "previousLanguage": {
        "type": "string",
        "isOptional": true
      },
      "contentLanguage": {
        "type": "string",
        "isOptional": true
      },
      "contentType": {
        "type": "string",
        "isOptional": true
      },
      "lessonType": {
        "type": "string",
        "isOptional": true
      },
      "lessonId": {
        "type": "string",
        "isOptional": true
      },
      "trackId": {
        "type": "string",
        "isOptional": true
      },
      "playlistId": {
        "type": "string",
        "isOptional": true
      },
      "appearsIn": {
        "type": "string",
        "isOptional": true
      },
      "filters": {
        "type": "string",
        "isOptional": true
      },
      "style": {
        "type": "string",
        "isOptional": true
      },
      "isInProgress": {
        "type": "boolean",
        "isOptional": true
      },
      "isCertification": {
        "type": "boolean",
        "isOptional": true
      },
      "contentId": {
        "type": "string",
        "isOptional": true
      },
      "privacy": {
        "type": "string",
        "isOptional": true
      },
      "recommendationStrategy": {
        "type": "string",
        "isOptional": true
      },
      "buttonStyle": {
        "type": "string",
        "isOptional": true
      },
      "hubPreference": {
        "type": "string",
        "isOptional": true
      },
      "minutes": {
        "type": "number",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "item": {
        "type": "string",
        "isOptional": true
      },
      "hub": {
        "type": "string",
        "isOptional": true
      },
      "previousHub": {
        "type": "string",
        "isOptional": true
      },
      "currency": {
        "type": "string",
        "isOptional": true
      },
      "ownedPlan": {
        "type": "string",
        "isOptional": true
      },
      "recommendedBecauseLessonId": {
        "type": "string",
        "isOptional": true
      },
      "publicAchievementId": {
        "type": "string",
        "isOptional": true
      },
      "requestedLanguage": {
        "type": "string",
        "isOptional": true
      },
      "isPaidAccount": {
        "type": "string",
        "isOptional": true
      },
      "position": {
        "type": "string",
        "isOptional": true
      },
      "viralSourceUserId": {
        "type": "string",
        "isOptional": true
      },
      "newHub": {
        "type": "string",
        "isOptional": true
      },
      "pathname": {
        "type": "string",
        "isOptional": true
      },
      "title": {
        "type": "string",
        "isOptional": true
      },
      "section": {
        "type": "string",
        "isOptional": true
      },
      "recommendationType": {
        "type": "string",
        "isOptional": true
      },
      "topicPreference": {
        "type": "string",
        "isOptional": true
      },
      "whichButton": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": "string",
        "isOptional": true
      },
      "viralSourcePortalId": {
        "type": "string",
        "isOptional": true
      },
      "recommendedBecauseTrackId": {
        "type": "string",
        "isOptional": true
      },
      "homepageUrl": {
        "type": "string",
        "isOptional": true
      },
      "option": {
        "type": "string",
        "isOptional": true
      },
      "cardNumber": {
        "type": "string",
        "isOptional": true
      },
      "id": {
        "type": "string",
        "isOptional": true
      },
      "preferredTopic": {
        "type": "string",
        "isOptional": true
      },
      "recommendationSeedId": {
        "type": "string",
        "isOptional": true
      },
      "from": {
        "type": "string",
        "isOptional": true
      },
      "to": {
        "type": "string",
        "isOptional": true
      },
      "language": {
        "type": "string",
        "isOptional": true
      },
      "saved": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "organisation": {
        "type": "string",
        "isOptional": true
      },
      "organisationUrl": {
        "type": "string",
        "isOptional": true
      },
      "professorId": {
        "type": "string",
        "isOptional": true
      },
      "creatorHubId": {
        "type": "string",
        "isOptional": true
      },
      "shortId": {
        "type": "string",
        "isOptional": true
      },
      "shortName": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "useCases": {
        "type": "array",
        "isOptional": true
      },
      "platform": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "learning-center"
  },
  "contentInteraction": {
    "name": "content interaction",
    "class": "interaction",
    "properties": {
      "lessonId": {
        "type": "string",
        "isOptional": true
      },
      "trackId": {
        "type": "string",
        "isOptional": true
      },
      "lessonName": {
        "type": "string",
        "isOptional": true
      },
      "playlistId": {
        "type": "string",
        "isOptional": true
      },
      "playlistName": {
        "type": "string",
        "isOptional": true
      },
      "isHubspotPlaylist": {
        "type": "boolean",
        "isOptional": true
      },
      "productName": {
        "type": "string",
        "isOptional": true
      },
      "trackName": {
        "type": "string",
        "isOptional": true
      },
      "playerType": {
        "type": "string",
        "isOptional": true
      },
      "contentName": {
        "type": "string",
        "isOptional": true
      },
      "displayOrder": {
        "type": "string",
        "isOptional": true
      },
      "isUntrackedExercise": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "graded": {
        "type": "string",
        "isOptional": true
      },
      "resourceTitle": {
        "type": "string",
        "isOptional": true
      },
      "questionId": {
        "type": "string",
        "isOptional": true
      },
      "resourceUrl": {
        "type": "string",
        "isOptional": true
      },
      "quizId": {
        "type": "string",
        "isOptional": true
      },
      "linkType": {
        "type": "string",
        "isOptional": true
      },
      "manuallyApproved": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "contentLanguage": {
        "type": "string",
        "isOptional": true
      },
      "contentId": {
        "type": "string",
        "isOptional": true
      },
      "contentType": {
        "type": "string",
        "isOptional": true
      },
      "businessObjectives": {
        "type": "array",
        "isOptional": true
      },
      "useCases": {
        "type": "array",
        "isOptional": true
      },
      "creatorHubId": {
        "type": "string",
        "isOptional": true
      },
      "shortId": {
        "type": "string",
        "isOptional": true
      },
      "shortName": {
        "type": "string",
        "isOptional": true
      },
      "linkText": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "videoType": {
        "type": "string",
        "isOptional": true
      },
      "platform": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "learning-center"
  },
  "contentProgress": {
    "name": "content progress",
    "class": "usage",
    "properties": {
      "lessonId": {
        "type": "string",
        "isOptional": true
      },
      "trackId": {
        "type": "string",
        "isOptional": true
      },
      "lessonName": {
        "type": "string",
        "isOptional": true
      },
      "playlistId": {
        "type": "string",
        "isOptional": true
      },
      "playlistName": {
        "type": "string",
        "isOptional": true
      },
      "isHubspotPlaylist": {
        "type": "boolean",
        "isOptional": true
      },
      "playerType": {
        "type": "string",
        "isOptional": true
      },
      "trackName": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "contentLanguage": {
        "type": "string",
        "isOptional": true
      },
      "viewDuration": {
        "type": "number",
        "isOptional": true
      },
      "contentId": {
        "type": "string",
        "isOptional": true
      },
      "contentType": {
        "type": "string",
        "isOptional": true
      },
      "businessObjectives": {
        "type": "array",
        "isOptional": true
      },
      "useCases": {
        "type": "array",
        "isOptional": true
      },
      "creatorHubId": {
        "type": "string",
        "isOptional": true
      },
      "shortId": {
        "type": "string",
        "isOptional": true
      },
      "shortName": {
        "type": "string",
        "isOptional": true
      },
      "platform": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "learning-center"
  },
  "activation": {
    "name": "activation",
    "class": "activation",
    "properties": {
      "lessonId": {
        "type": "string",
        "isOptional": true
      },
      "lessonName": {
        "type": "string",
        "isOptional": true
      },
      "trackName": {
        "type": "string",
        "isOptional": true
      },
      "playerType": {
        "type": "string",
        "isOptional": true
      },
      "trackId": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "contentLanguage": {
        "type": "string",
        "isOptional": true
      },
      "contentId": {
        "type": "string",
        "isOptional": true
      },
      "contentType": {
        "type": "string",
        "isOptional": true
      },
      "platform": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "learning-center"
  },
  "teamInteraction": {
    "name": "team",
    "class": "interaction",
    "properties": {
      "type": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "value": {
        "type": "string",
        "isOptional": true
      },
      "contentId": {
        "type": "string",
        "isOptional": true
      },
      "contentName": {
        "type": "string",
        "isOptional": true
      },
      "position": {
        "type": "number",
        "isOptional": true
      },
      "platform": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "learning-center"
  },
  "examInteraction": {
    "name": "exam interaction",
    "class": "interaction",
    "properties": {
      "passed": {
        "type": "string",
        "isOptional": true
      },
      "examAttemptId": {
        "type": "string",
        "isOptional": true
      },
      "score": {
        "type": "string",
        "isOptional": true
      },
      "trigger": {
        "type": "string",
        "isOptional": true
      },
      "completionPercentage": {
        "type": "string",
        "isOptional": true
      },
      "action": [
        "start",
        "progress",
        "resume",
        "completed",
        "send-breakdown",
        "time-expired",
        "render-triage"
      ],
      "examId": "number",
      "examLength": "number",
      "trackId": "string",
      "trackName": "string",
      "platform": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "learning-center"
  },
  "awardInteraction": {
    "name": "award interaction",
    "class": "interaction",
    "properties": {
      "context": {
        "type": "string",
        "isOptional": true
      },
      "destinationUrl": {
        "type": "string",
        "isOptional": true
      },
      "privacy": {
        "type": "string",
        "isOptional": true
      },
      "urlCount": {
        "type": "string",
        "isOptional": true
      },
      "view": {
        "type": "string",
        "isOptional": true
      },
      "socialName": {
        "type": "string",
        "isOptional": true
      },
      "action": [
        "view-modal",
        "download-certificate",
        "cancel-avatar-upload",
        "copy-badge-code",
        "close-achievement-preview-modal",
        "close-avatar-alert",
        "click-share-this-cert",
        "click-upload-avatar",
        "social-share",
        "send-to-upwork",
        "generate-public-urls",
        "toggle-privacy",
        "upload-avatar",
        "view-sharing-controls",
        "view-achievement-preview-modal"
      ],
      "awardCode": {
        "type": "string",
        "isOptional": true
      },
      "trackId": "string",
      "trackName": "string",
      "platform": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "learning-center"
  },
  "filterInteraction": {
    "name": "filter interaction",
    "class": "interaction",
    "properties": {
      "isTag": {
        "type": "string",
        "isOptional": true
      },
      "defaultValue": {
        "type": "string",
        "isOptional": true
      },
      "isDropdown": {
        "type": "boolean",
        "isOptional": true
      },
      "action": [
        "filter-selected",
        "filter-deselected",
        "filter-menu-opened",
        "default-language-filter-set",
        "default-language-filter-changed",
        "default-language-filter-returned"
      ],
      "key": "string",
      "value": "string",
      "platform": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "learning-center"
  },
  "catalogDropdownInteraction": {
    "name": "catalog dropdown interaction",
    "class": "interaction",
    "properties": {
      "key": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      },
      "action": [
        "catalog-dropdown-opened",
        "catalog-option-selected"
      ],
      "platform": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "learning-center"
  },
  "navInteraction": {
    "name": "academy nav interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "href": {
        "type": "string",
        "isOptional": true
      },
      "searchQuery": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      },
      "platform": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "learning-center"
  },
  "publicAchievementInteraction": {
    "name": "public achievement interaction",
    "class": "interaction",
    "properties": {
      "buttonType": {
        "type": "string",
        "isOptional": true
      },
      "href": {
        "type": "string",
        "isOptional": true
      },
      "isExternalLink": {
        "type": "string",
        "isOptional": true
      },
      "isResponsive": {
        "type": "string",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "action": [
        "not-found",
        "view-achievement",
        "click-footer-cta-button",
        "click-primary-cert",
        "click-header-nav-button"
      ],
      "publicId": "string",
      "language": "string",
      "platform": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "learning-center"
  },
  "playlistInteraction": {
    "name": "playlist interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "playlist-created",
        "playlist-duplicated",
        "duplicate-playlist-click",
        "playlist-details-updated",
        "close-create-modal",
        "edit-details-click",
        "choose-thumbnail",
        "upload-thumbnail",
        "add-to-new-playlist",
        "search-items",
        "add-to-playlist",
        "remove-item-from-playlist",
        "save-item-changes",
        "cancel-item-changes",
        "start-playlist",
        "continue-playlist",
        "share-playlist",
        "create-playlist",
        "save-playlist",
        "remove-playlist",
        "archive-playlist",
        "unarchive-playlist",
        "navigator-dropdown-open",
        "navigator-dropdown-item-clicked",
        "navigator-dropdown-view-playlist-clicked",
        "assign-playlist-clicked",
        "playlist-assigned",
        "playlist-due-date-update",
        "playlist-unassigned",
        "upload-playlist-thumbnail-click",
        "upload-playlist-thumbnail-disclaimer-close-click",
        "complete-playlist"
      ],
      "isOwner": {
        "type": "boolean",
        "isOptional": true
      },
      "isHubspotPlaylist": {
        "type": "boolean",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "searchQuery": {
        "type": "string",
        "isOptional": true
      },
      "playlistId": {
        "type": "string",
        "isOptional": true
      },
      "trackId": {
        "type": "string",
        "isOptional": true
      },
      "lessonId": {
        "type": "string",
        "isOptional": true
      },
      "shortId": {
        "type": "string",
        "isOptional": true
      },
      "portalId": {
        "type": "number",
        "isOptional": true
      },
      "bulk": {
        "type": "boolean",
        "isOptional": true
      },
      "hubspotterId": {
        "type": "number",
        "isOptional": true
      },
      "date": {
        "type": "number",
        "isOptional": true
      },
      "assignee": {
        "type": "boolean",
        "isOptional": true
      },
      "numberOfSelected": {
        "type": "number",
        "isOptional": true
      },
      "to": {
        "type": "string",
        "isOptional": true
      },
      "platform": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "learning-center"
  },
  "wizardInteraction": {
    "name": "wizard interaction",
    "class": "interaction",
    "properties": {
      "contentType": {
        "type": "string",
        "isOptional": true
      },
      "currentStep": {
        "type": "string",
        "isOptional": true
      },
      "completedState": {
        "type": "string",
        "isOptional": true
      },
      "resultCount": {
        "type": "string",
        "isOptional": true
      },
      "categoryClicked": {
        "type": "string",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "stepClicked": {
        "type": "string",
        "isOptional": true
      },
      "checked": {
        "type": "boolean",
        "isOptional": true
      },
      "action": [
        "view-banner",
        "banner-click-take-quiz",
        "banner-click-view-results",
        "banner-click-retake-quiz",
        "banner-click-dont-show-again",
        "takeover-click-show-catalog",
        "takeover-click-take-quiz",
        "wizard-click-cancel",
        "wizard-click-category",
        "wizard-click-sub-category",
        "wizard-click-tools-group",
        "wizard-click-tool",
        "wizard-click-show-certs-only",
        "wizard-click-show-all-courses",
        "wizard-view-results",
        "wizard-click-back",
        "wizard-click-green-results-section",
        "wizard-expand-results-section-mobile",
        "wizard-click-view-results-on-catalog",
        "wizard-click-result-card",
        "wizard-toggle-include-english",
        "wizard-toggle-viewed"
      ],
      "platform": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "learning-center"
  },
  "ratingInteraction": {
    "name": "Rating Interaction",
    "namespace": "Learning Center",
    "class": "interaction",
    "properties": {
      "creatorHubId": {
        "type": "number",
        "isOptional": true
      },
      "subCategory": {
        "type": "array",
        "isOptional": true
      },
      "videoProgress": {
        "type": "number",
        "isOptional": true
      },
      "contentId": {
        "type": "number",
        "isOptional": true
      },
      "ratingReason": {
        "type": "array",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "progressLevel": {
        "type": "number",
        "isOptional": true
      },
      "professorId": {
        "type": "array",
        "isOptional": true
      },
      "ratingScore": {
        "type": "number",
        "isOptional": false
      },
      "hsSoftwareFilters": {
        "type": "array",
        "isOptional": true
      },
      "useCase": {
        "type": "array",
        "isOptional": true
      },
      "view": {
        "type": "string",
        "isOptional": true
      },
      "contentType": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "contentName": {
        "type": "string",
        "isOptional": true
      },
      "contentLanguage": {
        "type": "string",
        "isOptional": true
      },
      "playlistId": {
        "type": "string",
        "isOptional": true
      },
      "playlistName": {
        "type": "string",
        "isOptional": true
      },
      "isHubspotPlaylist": {
        "type": "boolean",
        "isOptional": true
      },
      "platform": {
        "type": "string",
        "isOptional": true
      }
    }
  },
  "aiButtonInteraction": {
    "name": "aiButtonInteraction",
    "class": "interaction",
    "properties": {
      "type": {
        "type": "string"
      },
      "featureId": {
        "type": "string",
        "isOptional": true
      },
      "featureCategoryId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ai-components-ui-library",
    "version": "1"
  },
  "copilotActionButtonInteraction": {
    "name": "copilotActionButtonInteraction",
    "class": "interaction",
    "properties": {
      "type": {
        "type": "string"
      },
      "prompt": {
        "type": "string",
        "isOptional": true
      },
      "hasPrefillValues": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ai-components-ui-library",
    "version": "1"
  },
  "copyMessageInteraction": {
    "name": "copyMessageInteraction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "prompt_copied"
        ]
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ai-components-ui-library",
    "version": "1"
  },
  "feedbackInteraction": {
    "name": "inlineFeedbackInteraction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "prompt_upvoted",
          "prompt_upvote_removed",
          "prompt_downvoted",
          "prompt_downvote_removed"
        ]
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ai-components-ui-library",
    "version": "1"
  },
  "fileManagerLib": {
    "name": "File Manager Lib",
    "class": "usage",
    "properties": {
      "componentName": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerSetPanelExploreFiles": {
    "name": "Explore Files",
    "class": "interaction",
    "properties": {
      "panel": "string",
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerExploreFiles": {
    "name": "Explore Files",
    "class": "interaction",
    "namespace": "file-picker",
    "version": "v2",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    }
  },
  "fileManagerImageOptimization": {
    "name": "Change image optimization setting",
    "class": "interaction",
    "properties": {
      "setting": "string",
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerManageFiles": {
    "name": "Manage Files",
    "class": "interaction",
    "properties": {
      "count": {
        "type": "number",
        "isOptional": true
      },
      "fileSource": {
        "type": [
          "AI_GENERATED",
          "CANVA",
          "SHUTTERSTOCK"
        ],
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "filePickerMultiSelect": {
    "name": "Manage Files",
    "class": "interaction",
    "properties": {
      "fileCount": {
        "type": "number"
      },
      "limit": {
        "type": "number"
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerManageFolders": {
    "name": "Manage Folders",
    "class": "interaction",
    "namespace": "file-picker",
    "version": "v2",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    }
  },
  "fileManagerBrowseShutterstock": {
    "name": "Browse Shutterstock",
    "class": "interaction",
    "namespace": "file-picker",
    "version": "v2",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    }
  },
  "fileManagerAlert": {
    "name": "Alert interaction",
    "class": "interaction",
    "namespace": "file-picker",
    "version": "v2",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    }
  },
  "fileManagerBulkImport": {
    "name": "Bulk Import Images",
    "class": "interaction",
    "properties": {
      "action": "string",
      "imageCount": {
        "type": "number",
        "isOptional": true
      },
      "isImageFile": {
        "type": "boolean",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerLibErrorDisplay": {
    "name": "Error display",
    "class": "view",
    "properties": {
      "type": "string",
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileUsage": {
    "name": "File Usage",
    "class": "usage",
    "properties": {
      "isBulk": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-manager",
    "version": "v2"
  },
  "fileManagerVideoInteraction": {
    "name": "video interaction",
    "class": "interaction",
    "properties": {
      "videoTitle": {
        "type": "string",
        "isOptional": true
      },
      "language": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-manager",
    "version": "v2"
  },
  "fileManagerUpload": {
    "name": "upload file",
    "class": "interaction",
    "properties": {
      "size": {
        "type": "number",
        "isOptional": true
      },
      "errorType": {
        "type": "string",
        "isOptional": true
      },
      "statusCode": {
        "type": "number",
        "isOptional": true
      },
      "videoDuration": {
        "type": "number",
        "isOptional": true
      },
      "videoHostingProvider": {
        "type": [
          "mux"
        ],
        "isOptional": true
      },
      "multiPartUpload": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-manager",
    "version": "v2"
  },
  "fileManagerUploadDeduplication": {
    "name": "check upload duplicates",
    "class": "interaction",
    "properties": {
      "hasData": {
        "type": "boolean",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "size": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-manager",
    "version": "v2"
  },
  "fileManagerVideoPQL": {
    "name": "Video PQL",
    "class": "interaction",
    "properties": {
      "alert": {
        "type": "string",
        "isOptional": true
      },
      "limit": {
        "type": "number",
        "isOptional": true
      },
      "quantityRemaining": {
        "type": "number",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-manager",
    "version": "v2"
  },
  "fileManagerImageGeneration": {
    "name": "image generation",
    "class": "interaction",
    "properties": {
      "errorCount": {
        "type": "number",
        "isOptional": true
      },
      "isFeedbackPositive": {
        "type": "boolean",
        "isOptional": true
      },
      "feedbackText": {
        "type": "string",
        "isOptional": true
      },
      "resolution": {
        "type": "string",
        "isOptional": true
      },
      "style": {
        "type": "string",
        "isOptional": true
      },
      "correlationId": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-manager",
    "version": "v2"
  },
  "adobeExpressInteraction": {
    "name": "adobe express",
    "class": "interaction",
    "namespace": "file-manager",
    "version": "v2",
    "properties": {
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    }
  }
};